export const environment = {
  production: true,
  UPDATE_FAST_INTERVAL: 2000,
  UPDATE_SLOW_INTERVAL: 7000,
  SAVE_INTERVAL: 2500,
  API_DOMAIN: 'https://api.flxion.com'
};
